<div class="flex flex-col p-1 lg:p-3 gap-x-4">
  <span class="text-gray-900 text-2xl font-bold mb-2">Driver Calendar</span>
  <div class="flex flex-row">
    <div
      [ngClass]="{ 'w-full': !isDetailsViewOpen, 'w-2/3': isDetailsViewOpen }"
      class="card-with-shadow p-5 bg-white transition-all duration-300 flex flex-col"
    >
      <div>
        <mat-slide-toggle
          *lohiFeatureFlag="'showArchivedHitchShiftCalendar'"
          class="mb-3"
          [checked]="isShowArchivedCancelHitchAndShift$ | async"
          (change)="toggleArchiveHitchShift()"
        >
          Show archived or canceled hitches/shifts
        </mat-slide-toggle>
      </div>
      <div class="flex flex-row justify-between mb-3">
        <div class="text-gray-900 font-bold text-2xl">{{ today | date: 'MMMM y' }}</div>
        <mat-select [formControl]="regionsFilterControl" style="width: 200px !important">
          <mat-option [value]="-1">All Regions</mat-option>
          <mat-option [value]="region.id" *ngFor="let region of regions$ | async; trackBy: 'id' | trackByKey">
            {{ region.name }}
          </mat-option>
        </mat-select>
      </div>
      <div *ngIf="driversHitchCalendarWeeks$$ | async as driversHitchCalendarWeeks" class="w-full flex flex-col">
        <div class="text-base font-bold text-gray-600 border-gray-300 border-b flex flex-row">
          <span class="py-2 border-gray-300 border-t flex-1 text-center">Monday</span>
          <span class="py-2 border-gray-300 border-t flex-1 text-center">Tuesday</span>
          <span class="py-2 border-gray-300 border-t flex-1 text-center">Wednesday</span>
          <span class="py-2 border-gray-300 border-t flex-1 text-center">Thursday</span>
          <span class="py-2 border-gray-300 border-t flex-1 text-center">Friday</span>
          <span class="py-2 border-gray-300 border-t flex-1 text-center">Saturday</span>
          <span class="py-2 border-gray-300 border-t flex-1 text-center">Sunday</span>
        </div>
        <div
          *ngFor="let week of driversHitchCalendarWeeks; trackBy: 'id' | trackByKey"
          class="h-16 border-gray-300 border-b flex flex-row"
        >
          <div
            *ngFor="let day of week; trackBy: 'id' | trackByKey"
            class="border-r border-gray-300 last:border-0 flex-1 min-w-0"
          >
            <div
              class="flex flex-col relative h-full w-full"
              [class.cursor-pointer]="day.currentMonth"
              (click)="toggleHitchDetails(day)"
            >
              <ng-container *ngIf="day.currentMonth">
                <div class="flex flex-col gap-y-1 absolute top-0 left-0 ml-1 mt-4">
                  <!-- No Show Drivers -->
                  <div
                    *ngIf="
                      ((isShowArchivedCancelHitchAndShift$ | async) === true &&
                        day.driverStatusCounts.noShowWithArchived + day.driverStatusCounts.noShowWithoutArchived > 0) ||
                      ((isShowArchivedCancelHitchAndShift$ | async) === false &&
                        day.driverStatusCounts.noShowWithoutArchived > 0)
                    "
                  >
                    <div class="flex flex-row items-center">
                      <span
                        class="px-1 font-bold leading-none bg-orange-500 text-white text-xs mr-1 self-center rounded-full"
                        style="padding-bottom: 2px; padding-top: 2px"
                      >
                        {{
                          (isShowArchivedCancelHitchAndShift$ | async) === true
                            ? day.driverStatusCounts.noShowWithArchived + day.driverStatusCounts.noShowWithoutArchived
                            : day.driverStatusCounts.noShowWithoutArchived
                        }}
                      </span>
                      <span class="text-orange-500 leading-none text-sm font-bold">No Show</span>
                    </div>
                  </div>

                  <!-- Excused Drivers -->
                  <div
                    *ngIf="
                      ((isShowArchivedCancelHitchAndShift$ | async) === true &&
                        day.driverStatusCounts.excusedWithArchived + day.driverStatusCounts.excusedWithoutArchived >
                          0) ||
                      ((isShowArchivedCancelHitchAndShift$ | async) === false &&
                        day.driverStatusCounts.excusedWithoutArchived > 0)
                    "
                  >
                    <div class="flex flex-row items-center">
                      <span
                        class="px-1 bg-gray-600 font-bold leading-none text-white text-xs mr-1 self-center rounded-full"
                        style="padding-bottom: 2px; padding-top: 2px"
                      >
                        {{
                          (isShowArchivedCancelHitchAndShift$ | async) === true
                            ? day.driverStatusCounts.excusedWithArchived + day.driverStatusCounts.excusedWithoutArchived
                            : day.driverStatusCounts.excusedWithoutArchived
                        }}
                      </span>
                      <span class="text-gray-600 leading-none text-sm font-bold">Excused</span>
                    </div>
                  </div>
                </div>
              </ng-container>
              <div class="absolute right-0 mt-1 top-0 mr-2 flex flex-row">
                <span class="material-icons text-yellow-500 text-base" *ngIf="day.events && day.events.length > 0"
                  >star</span
                >
                <span
                  class="leading-none text-base font-bold"
                  [class.text-gray-400]="!day.currentMonth"
                  [class.text-gray-600]="day.currentMonth"
                  >{{ day.date | date: 'd' }}</span
                >
              </div>
              <ng-container *ngIf="day.currentMonth">
                <div class="flex flex-col absolute bottom-0 mb-1 w-full h-8 justify-end">
                  <!-- Show hitches starting today, only show archived based on the toggle -->
                  <ng-container
                    *ngFor="
                      let hitch of day.hitchesStartingToday | orderBy: 'desc':'startMinutes';
                      trackBy: 'id' | trackByKey
                    "
                  >
                    <span
                      class="bg-blue-500 self-end"
                      style="height: 2px; margin-right: -1px"
                      [style.width.%]="((1440 - hitch.startMinutes) / 1440) * 100 + 1"
                      *ngIf="!hitch.archivedAt || (isShowArchivedCancelHitchAndShift$ | async)"
                    ></span>
                  </ng-container>

                  <!-- Show hitches ending today, only show archived based on the toggle -->
                  <ng-container
                    *ngFor="
                      let hitch of day.hitchesEndingToday | orderBy: 'asc':'endMinutes';
                      trackBy: 'id' | trackByKey
                    "
                  >
                    <span
                      class="bg-blue-500"
                      style="height: 2px"
                      [style.width.%]="((1440 - hitch.endMinutes) / 1440) * 100"
                      *ngIf="!hitch.archivedAt || (isShowArchivedCancelHitchAndShift$ | async)"
                    ></span>
                  </ng-container>

                  <!-- Show full-day hitches, only show archived based on the toggle -->
                  <ng-container *ngFor="let hitch of day.hitchesFullDay; trackBy: 'id' | trackByKey">
                    <span
                      class="bg-blue-500"
                      style="height: 2px; width: calc(100% + 1px)"
                      *ngIf="!hitch.archivedAt || (isShowArchivedCancelHitchAndShift$ | async)"
                    ></span>
                  </ng-container>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      [ngClass]="{ 'w-1/3': isDetailsViewOpen, hidden: !isDetailsViewOpen }"
      class="card-with-shadow p-5 bg-white transition-all duration-300 min-w-0 flex flex-col relative overflow-auto"
    >
      <div *ngIf="selectedDay" class="grid gap-y-3">
        <div>
          <p class="font-bold text-2xl">
            {{ selectedDay.date | date: 'MMMM d, y' }}
            <span class="text-gray-600">{{ selectedDay.date | date: 'EEEE' }}</span>
          </p>
          <hr class="h-0.5 mt-1 bg-gray-400 border-0.2 opacity-25" />
        </div>

        <ng-container *ngIf="selectedDay.events && selectedDay.events.length > 0">
          <div class="flex flex-row items-center gap-x-1">
            <mat-icon (click)="toggleContentEvents()" class="text-gray-600">
              {{ isOpenEventToggle ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}
            </mat-icon>
            <span class="text-lg font-bold">Bonus events</span>
            <span
              class="px-2 py-1 font-bold leading-none bg-orange-500 text-white text-sm mr-1 self-center rounded-full"
            >
              {{ selectedDay.events.length }}
            </span>
          </div>

          <div *ngIf="isOpenEventToggle">
            <span *ngFor="let event of selectedDay.events; trackBy: 'id' | trackByKey" class="grid gap-y-1">
              <ng-container [ngSwitch]="event.eventType">
                <ng-container *ngSwitchCase="'bonus'">
                  <ng-container [ngSwitch]="event.ordersPricingType">
                    <ng-container *ngSwitchCase="'flat_rate_cents'">
                      <div class="card-with-shadow p-2 bg-gray-200 rounded-lg flex flex-row items-center mb-2">
                        <div class="flex flex-row items-center gap-x-2">
                          <div class="flex flex-col items-center bg-white rounded-lg shadow-sm">
                            <div class="p-2 bg-red-500 text-white font-bold text-center rounded-t-lg w-full">
                              {{ event.startsAt | date: 'MMM' }}
                            </div>
                            <div class="p-2">
                              <div class="text-3xl font-bold text-center pb-2">{{ event.startsAt | date: 'd' }}</div>
                              <div class="text-sm text-center text-gray-700">
                                {{ event.endsAt | date: 'h:mma' }} {{ timeZoneAbbreviation }}
                              </div>
                            </div>
                          </div>
                          <mat-icon class="text-4xl">arrow_forward</mat-icon>
                          <div class="flex flex-col items-center bg-white rounded-lg shadow-sm">
                            <div class="p-2 bg-red-500 text-white font-bold text-center rounded-t-lg w-full">
                              {{ event.endsAt | date: 'MMM' }}
                            </div>
                            <div class="p-2">
                              <div class="text-3xl font-bold text-center pb-2">{{ event.endsAt | date: 'd' }}</div>
                              <div class="text-sm text-center text-gray-700">
                                {{ event.endsAt | date: 'h:mma' }} {{ timeZoneAbbreviation }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="mt-2 p-2 text-center flex-1">
                          <p class="font-bold">
                            {{ event.name }}
                            Additional Bonus of {{ event.ordersPricingValue | currencyInPennies }}
                          </p>
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="'percent'">
                      <div class="card-with-shadow p-2 bg-gray-200 rounded-lg flex flex-row items-center mb-2">
                        <div class="flex flex-row items-center gap-x-2">
                          <div class="flex flex-col items-center bg-white rounded-lg shadow-sm">
                            <div class="p-2 bg-red-500 text-white font-bold text-center rounded-t-lg w-full">
                              {{ event.startsAt | date: 'MMM' }}
                            </div>
                            <div class="p-2">
                              <div class="text-3xl font-bold text-center pb-2">{{ event.startsAt | date: 'd' }}</div>
                              <div class="text-sm text-center text-gray-700">
                                {{ event.endsAt | date: 'h:mma' }} {{ timeZoneAbbreviation }}
                              </div>
                            </div>
                          </div>
                          <mat-icon class="text-4xl">arrow_forward</mat-icon>
                          <div class="flex flex-col items-center bg-white rounded-lg shadow-sm">
                            <div class="p-2 bg-red-500 text-white font-bold text-center rounded-t-lg w-full">
                              {{ event.endsAt | date: 'MMM' }}
                            </div>
                            <div class="p-2">
                              <div class="text-3xl font-bold text-center pb-2">{{ event.endsAt | date: 'd' }}</div>
                              <div class="text-sm text-center text-gray-700">
                                {{ event.endsAt | date: 'h:mma' }} {{ timeZoneAbbreviation }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="mt-2 p-2 text-center flex-1">
                          <p class="font-bold">
                            {{ event.name }}
                            Additional Bonus of {{ event.ordersPricingValue * 100 | number }}%
                          </p>
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="'per_ton'">
                      <div class="card-with-shadow p-2 bg-gray-200 rounded-lg flex flex-row items-center mb-2">
                        <div class="flex flex-row items-center gap-x-2">
                          <div class="flex flex-col items-center bg-white rounded-lg shadow-sm">
                            <div class="p-2 bg-red-500 text-white font-bold text-center rounded-t-lg w-full">
                              {{ event.startsAt | date: 'MMM' }}
                            </div>
                            <div class="p-2">
                              <div class="text-3xl font-bold text-center pb-2">{{ event.startsAt | date: 'd' }}</div>
                              <div class="text-sm text-center text-gray-700">
                                {{ event.endsAt | date: 'h:mma' }} {{ timeZoneAbbreviation }}
                              </div>
                            </div>
                          </div>
                          <mat-icon class="text-4xl">arrow_forward</mat-icon>
                          <div class="flex flex-col items-center bg-white rounded-lg shadow-sm">
                            <div class="p-2 bg-red-500 text-white font-bold text-center rounded-t-lg w-full">
                              {{ event.endsAt | date: 'MMM' }}
                            </div>
                            <div class="p-2">
                              <div class="text-3xl font-bold text-center pb-2">{{ event.endsAt | date: 'd' }}</div>
                              <div class="text-sm text-center text-gray-700">
                                {{ event.endsAt | date: 'h:mma' }} {{ timeZoneAbbreviation }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="mt-2 p-2 text-center flex-1">
                          <p class="font-bold">
                            {{ event.name }}
                            Additional Bonus of {{ event.ordersPricingValue | currencyInPennies }} per Ton
                          </p>
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="'per_mile_cents'">
                      <div class="card-with-shadow p-2 bg-gray-200 rounded-lg flex flex-row items-center mb-2">
                        <div class="flex flex-row items-center gap-x-2">
                          <div class="flex flex-col items-center bg-white rounded-lg shadow-sm">
                            <div class="p-2 bg-red-500 text-white font-bold text-center rounded-t-lg w-full">
                              {{ event.startsAt | date: 'MMM' }}
                            </div>
                            <div class="p-2">
                              <div class="text-3xl font-bold text-center pb-2">{{ event.startsAt | date: 'd' }}</div>
                              <div class="text-sm text-center text-gray-700">
                                {{ event.endsAt | date: 'h:mma' }} {{ timeZoneAbbreviation }}
                              </div>
                            </div>
                          </div>
                          <mat-icon class="text-4xl">arrow_forward</mat-icon>
                          <div class="flex flex-col items-center bg-white rounded-lg shadow-sm">
                            <div class="p-2 bg-red-500 text-white font-bold text-center rounded-t-lg w-full">
                              {{ event.endsAt | date: 'MMM' }}
                            </div>
                            <div class="p-2">
                              <div class="text-3xl font-bold text-center pb-2">{{ event.endsAt | date: 'd' }}</div>
                              <div class="text-sm text-center text-gray-700">
                                {{ event.endsAt | date: 'h:mma' }} {{ timeZoneAbbreviation }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="mt-2 p-2 text-center flex-1">
                          <p class="font-bold">
                            {{ event.name }}
                            Additional Bonus of {{ event.ordersPricingValue | currencyInPennies }} per Mile
                          </p>
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="'deadhead'">
                  <ng-container [ngSwitch]="event.ordersPricingType">
                    <ng-container *ngSwitchCase="'flat_rate_cents'">
                      <div class="card-with-shadow p-2 bg-gray-200 rounded-lg flex flex-row items-center mb-2">
                        <div class="flex flex-row items-center gap-x-2">
                          <div class="flex flex-col items-center bg-white rounded-lg shadow-sm">
                            <div class="p-2 bg-red-500 text-white font-bold text-center rounded-t-lg w-full">
                              {{ event.startsAt | date: 'MMM' }}
                            </div>
                            <div class="p-2">
                              <div class="text-3xl font-bold text-center pb-2">{{ event.startsAt | date: 'd' }}</div>
                              <div class="text-sm text-center text-gray-700">
                                {{ event.endsAt | date: 'h:mma' }} {{ timeZoneAbbreviation }}
                              </div>
                            </div>
                          </div>
                          <mat-icon class="text-4xl">arrow_forward</mat-icon>
                          <div class="flex flex-col items-center bg-white rounded-lg shadow-sm">
                            <div class="p-2 bg-red-500 text-white font-bold text-center rounded-t-lg w-full">
                              {{ event.endsAt | date: 'MMM' }}
                            </div>
                            <div class="p-2">
                              <div class="text-3xl font-bold text-center pb-2">{{ event.endsAt | date: 'd' }}</div>
                              <div class="text-sm text-center text-gray-700">
                                {{ event.endsAt | date: 'h:mma' }} {{ timeZoneAbbreviation }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="mt-2 p-2 text-center flex-1">
                          <p class="font-bold">
                            {{ event.name }}
                            Additional Bonus of {{ event.ordersPricingValue | currencyInPennies }}
                          </p>
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="'percent'">
                      <div class="card-with-shadow p-2 bg-gray-200 rounded-lg flex flex-row items-center mb-2">
                        <div class="flex flex-row items-center gap-x-2">
                          <div class="flex flex-col items-center bg-white rounded-lg shadow-sm">
                            <div class="p-2 bg-red-500 text-white font-bold text-center rounded-t-lg w-full">
                              {{ event.startsAt | date: 'MMM' }}
                            </div>
                            <div class="p-2">
                              <div class="text-3xl font-bold text-center pb-2">{{ event.startsAt | date: 'd' }}</div>
                              <div class="text-sm text-center text-gray-700">
                                {{ event.endsAt | date: 'h:mma' }} {{ timeZoneAbbreviation }}
                              </div>
                            </div>
                          </div>
                          <mat-icon class="text-4xl">arrow_forward</mat-icon>
                          <div class="flex flex-col items-center bg-white rounded-lg shadow-sm">
                            <div class="p-2 bg-red-500 text-white font-bold text-center rounded-t-lg w-full">
                              {{ event.endsAt | date: 'MMM' }}
                            </div>
                            <div class="p-2">
                              <div class="text-3xl font-bold text-center pb-2">{{ event.endsAt | date: 'd' }}</div>
                              <div class="text-sm text-center text-gray-700">
                                {{ event.endsAt | date: 'h:mma' }} {{ timeZoneAbbreviation }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="mt-2 p-2 text-center flex-1">
                          <p class="font-bold">
                            {{ event.name }}
                            Additional Bonus of {{ event.ordersPricingValue * 100 }}%
                          </p>
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="'per_ton'">
                      <div class="card-with-shadow p-2 bg-gray-200 rounded-lg flex flex-row items-center mb-2">
                        <div class="flex flex-row items-center gap-x-2">
                          <div class="flex flex-col items-center bg-white rounded-lg shadow-sm">
                            <div class="p-2 bg-red-500 text-white font-bold text-center rounded-t-lg w-full">
                              {{ event.startsAt | date: 'MMM' }}
                            </div>
                            <div class="p-2">
                              <div class="text-3xl font-bold text-center pb-2">{{ event.startsAt | date: 'd' }}</div>
                              <div class="text-sm text-center text-gray-700">
                                {{ event.endsAt | date: 'h:mma' }} {{ timeZoneAbbreviation }}
                              </div>
                            </div>
                          </div>
                          <mat-icon class="text-4xl">arrow_forward</mat-icon>
                          <div class="flex flex-col items-center bg-white rounded-lg shadow-sm">
                            <div class="p-2 bg-red-500 text-white font-bold text-center rounded-t-lg w-full">
                              {{ event.endsAt | date: 'MMM' }}
                            </div>
                            <div class="p-2">
                              <div class="text-3xl font-bold text-center pb-2">{{ event.endsAt | date: 'd' }}</div>
                              <div class="text-sm text-center text-gray-700">
                                {{ event.endsAt | date: 'h:mma' }} {{ timeZoneAbbreviation }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="mt-2 p-2 text-center flex-1">
                          <p class="font-bold">
                            {{ event.name }}
                            Additional Bonus of {{ event.ordersPricingValue | currencyInPennies }} per Ton
                          </p>
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="'per_mile_cents'">
                      <div class="card-with-shadow p-2 bg-gray-200 rounded-lg flex flex-row items-center mb-2">
                        <div class="flex flex-row items-center gap-x-2">
                          <div class="flex flex-col items-center bg-white rounded-lg shadow-sm">
                            <div class="p-2 bg-red-500 text-white font-bold text-center rounded-t-lg w-full">
                              {{ event.startsAt | date: 'MMM' }}
                            </div>
                            <div class="p-2">
                              <div class="text-3xl font-bold text-center pb-2">{{ event.startsAt | date: 'd' }}</div>
                              <div class="text-sm text-center text-gray-700">
                                {{ event.endsAt | date: 'h:mma' }} {{ timeZoneAbbreviation }}
                              </div>
                            </div>
                          </div>
                          <mat-icon class="text-4xl">arrow_forward</mat-icon>
                          <div class="flex flex-col items-center bg-white rounded-lg shadow-sm">
                            <div class="p-2 bg-red-500 text-white font-bold text-center rounded-t-lg w-full">
                              {{ event.endsAt | date: 'MMM' }}
                            </div>
                            <div class="p-2">
                              <div class="text-3xl font-bold text-center pb-2">{{ event.endsAt | date: 'd' }}</div>
                              <div class="text-sm text-center text-gray-700">
                                {{ event.endsAt | date: 'h:mma' }} {{ timeZoneAbbreviation }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="mt-2 p-2 text-center flex-1">
                          <p class="font-bold">
                            {{ event.name }}
                            Additional Bonus of {{ event.ordersPricingValue | currencyInPennies }} per Mile
                          </p>
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>
                </ng-container>

                <!-- Driver Retention Event Type -->
                <ng-container *ngSwitchCase="'driver_retention'">
                  <div class="card-with-shadow p-2 bg-gray-200 rounded-lg flex flex-row items-center mb-2">
                    <div class="flex flex-row items-center gap-x-2">
                      <!-- Start Date -->
                      <div class="flex flex-col items-center bg-white rounded-lg shadow-sm">
                        <div class="p-2 bg-red-500 text-white font-bold text-center rounded-t-lg w-full">
                          {{ event.startsAt | date: 'MMM' }}
                        </div>
                        <div class="p-2">
                          <div class="text-3xl font-bold text-center pb-2">{{ event.startsAt | date: 'd' }}</div>
                          <div class="text-sm text-center text-gray-700">
                            {{ event.endsAt | date: 'h:mma' }} {{ timeZoneAbbreviation }}
                          </div>
                        </div>
                      </div>
                      <mat-icon class="text-4xl">arrow_forward</mat-icon>
                      <!-- End Date -->
                      <div class="flex flex-col items-center bg-white rounded-lg shadow-sm">
                        <div class="p-2 bg-red-500 text-white font-bold text-center rounded-t-lg w-full">
                          {{ event.endsAt | date: 'MMM' }}
                        </div>
                        <div class="p-2">
                          <div class="text-3xl font-bold text-center pb-2">{{ event.endsAt | date: 'd' }}</div>
                          <div class="text-sm text-center text-gray-700">
                            {{ event.endsAt | date: 'h:mma' }} {{ timeZoneAbbreviation }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="mt-2 p-2 text-center flex-1">
                      <p class="font-bold">{{ event.name }}</p>
                      <p class="text-gray-700">
                        Additional Bonus of {{ event.retentionsPricingValue | currencyInPennies }}
                      </p>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
            </span>
          </div>
        </ng-container>

        <ng-container *ngIf="getVisibleNoShowDrivers().length > 0 || hasNonArchivedHitch()">
          <div>
            <p class="text-2xl font-bold text-red-500">No Shows</p>
            <div
              *ngFor="let noShowDriver of getVisibleNoShowDrivers(); index as i; trackBy: trackByKeyNoShowDriver"
              class="flex flex-col gap-y-1"
            >
              <ng-container *ngIf="!noShowDriver.archivedAt || (isShowArchivedCancelHitchAndShift$ | async)">
                <div class="flex flex-row flex-wrap gap-y-2">
                  <div class="w-1/3 flex flex-col">
                    <span class="font-bold text-lg">{{ noShowDriver.name }}</span>
                    <span class="text-gray-600">{{ noShowDriver.regionName }}</span>
                  </div>
                  <div class="w-2/3">
                    <div class="flex flex-col">
                      <div
                        [ngClass]="getContainerClass(noShowDriver)"
                        class="font-bold w-full p-1 rounded-lg flex items-center justify-center gap-1 mb-1"
                      >
                        <mat-icon>{{ getMainIcon(noShowDriver) }}</mat-icon>
                        <span>{{ noShowDriver.startDateTimezone | date: 'M/d' }}</span>
                        <mat-icon>arrow_forward</mat-icon>
                        <span>{{ noShowDriver.lastDateTimezone | date: 'M/d' }}</span>
                        <mat-icon>alternate_email</mat-icon>
                        <span>
                          {{
                            noShowDriver.startDateTimezone
                              | date: 'yyyy-MM-ddTHH:mm:ssZ'
                              | addMinutes: noShowDriver.shiftStartMinute
                              | timeInTimezone: noShowDriver.regionTimezone
                          }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Divider between drivers -->
                <ng-container *ngIf="i < getVisibleNoShowDrivers().length - 1">
                  <hr class="h-0.5 my-1 bg-gray-400 border-0.2 opacity-25" />
                </ng-container>
              </ng-container>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="getVisibleExcusedDrivers().length > 0 || hasNonArchivedHitch()">
          <div>
            <p class="text-2xl font-bold text-red-500">Excused</p>
            <div
              *ngFor="let excusedDriver of getVisibleExcusedDrivers(); index as i; trackBy: trackByKeyExcusedDriver"
              class="flex flex-col gap-y-1"
            >
              <ng-container *ngIf="!excusedDriver.archivedAt || (isShowArchivedCancelHitchAndShift$ | async)">
                <div class="flex flex-row flex-wrap gap-y-2">
                  <div class="w-1/3 flex flex-col">
                    <span class="font-bold text-lg">{{ excusedDriver.name }}</span>
                    <span class="text-gray-600">{{ excusedDriver.regionName }}</span>
                  </div>
                  <div class="w-2/3">
                    <div class="flex flex-col">
                      <div
                        [ngClass]="getContainerClass(excusedDriver)"
                        class="font-bold w-full p-1 rounded-lg flex items-center justify-center gap-1 mb-1"
                      >
                        <mat-icon>{{ getMainIcon(excusedDriver) }}</mat-icon>
                        <span>{{ excusedDriver.startDateTimezone | date: 'M/d' }}</span>
                        <mat-icon>arrow_forward</mat-icon>
                        <span>{{ excusedDriver.lastDateTimezone | date: 'M/d' }}</span>
                        <mat-icon>alternate_email</mat-icon>
                        <span>
                          {{
                            excusedDriver.startDateTimezone
                              | date: 'yyyy-MM-ddTHH:mm:ssZ'
                              | addMinutes: excusedDriver.shiftStartMinute
                              | timeInTimezone: excusedDriver.regionTimezone
                          }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Divider between drivers -->
                <ng-container *ngIf="i < getVisibleExcusedDrivers().length - 1">
                  <hr class="h-0.5 my-1 bg-gray-400 border-0.2 opacity-25" />
                </ng-container>
              </ng-container>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="hitchesSelectedDay && hitchesSelectedDay.length > 0">
          <div class="mb-3">
            <p class="text-2xl font-bold">Driver Hitches & Regions</p>
            <div *ngFor="let hitch of hitchesSelectedDay; index as i; trackBy: trackByKeyHitch" class="flex flex-col">
              <div class="flex flex-row flex-wrap gap-y-2">
                <div class="w-1/3 flex flex-col" [ngClass]="hitch.archivedAt ? 'opacity-25' : ''">
                  <span class="font-bold text-lg">{{ hitch.driverName }}</span>
                  <span class="text-gray-600">{{ hitch.regionName }}</span>
                </div>
                <div class="w-2/3">
                  <div class="flex flex-col">
                    <ng-container *ngIf="hitch.startDateTimezone || hitch.lastDateTimezone">
                      <div
                        [ngClass]="getContainerClass(hitch)"
                        class="font-bold w-full p-1 rounded-lg flex items-center justify-center gap-1"
                      >
                        <mat-icon>{{ getMainIcon(hitch) }}</mat-icon>
                        <span>{{ hitch.startDateTimezone | date: 'M/d' }}</span>
                        <mat-icon>arrow_forward</mat-icon>
                        <span>{{ hitch.lastDateTimezone | date: 'M/d' }}</span>
                        <mat-icon>alternate_email</mat-icon>
                        <span>
                          {{
                            hitch.startDateTimezone
                              | date: 'yyyy-MM-ddTHH:mm:ssZ'
                              | addMinutes: hitch.shiftStartMinute
                              | timeInTimezone: hitch.regionTimezone
                          }}
                        </span>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>

              <ng-container *ngFor="let shift of hitch.driverShifts; index as i; trackBy: trackByKeyHitch">
                <div
                  class="w-full p-1 rounded-lg flex justify-between items-center my-1 bg-green-400 text-white"
                  [ngClass]="hitch.archivedAt ? 'opacity-25' : ''"
                >
                  <span class="font-bold">On Shift</span>
                  <span>
                    {{ shift.startsAt | timeInTimezone: hitch.regionTimezone }}
                    -
                    {{ shift.endsAt | timeInTimezone: hitch.regionTimezone }}
                  </span>
                </div>
              </ng-container>

              <ng-container *ngIf="i < hitchesSelectedDay.length - 1">
                <hr class="h-0.5 my-1 bg-gray-400 border-0.2 opacity-25" />
              </ng-container>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="selectedDay.hitchesFullDay.length < 1">
          <div class="flex flex-col items-center">
            <img class="h-10 mb-3" src="/assets/images/user-dash.svg" alt="user dash" />
            <p class="font-bold text-xl text-center">There are no drivers on hitch for the selected day</p>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
